import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import IfCondition from 'components/shared/IfCondition';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { QuotationData } from '../../models/quotations/Quotations';
import { CountryNameDisplay } from '../shared/CountryNameDisplay';
import { QuotationDetailsDataItem } from './QuotationDetailsDataItem';

const StyledDataWrapper = styled(Box)(({ theme }) => ({
    display: 'flex',
    gap: '20px',
    flexDirection: 'row',
    paddingTop: '30px',
    paddingBottom: '20px',
    '@media (max-width: 450px)': {
        flexDirection: 'column',
    },
}));
export const QuotationDetailsData: React.FC<{ quote: QuotationData }> = (
    props
) => {
    const { quote } = props;
    const { t } = useTranslation('quotations', {
        keyPrefix: 'QUOTATIONS.QUOTATION_DETAILS.DATA',
    });

    return (
        <>
            <StyledDataWrapper>
                <Box
                    sx={{ display: 'flex', flexDirection: 'row', gap: '20px' }}
                >
                    <QuotationDetailsDataItem title={t('BUYER_DETAILS')}>
                        <Typography>{quote.buyer?.name}</Typography>
                        <Typography>{quote.buyer?.phone}</Typography>
                    </QuotationDetailsDataItem>
                    <QuotationDetailsDataItem title={t('BUYER_SHIPPING')}>
                        <Typography sx={{ display: 'flex', gap: '2px' }}>
                            {quote.buyer && quote.buyer.country && (
                                <>
                                    <CountryNameDisplay
                                        countryCode={quote.buyer?.country}
                                    />
                                    ,{quote.buyer?.postcode}
                                </>
                            )}
                        </Typography>
                        <Typography>
                            {quote.buyer?.city}, {quote.buyer?.address1}
                        </Typography>
                        <Typography>{quote.buyer?.address2}</Typography>
                    </QuotationDetailsDataItem>
                </Box>

                <QuotationDetailsDataItem title={t('SELLER_DETAILS')}>
                    <Typography>{quote.seller?.company}</Typography>
                    <Typography>{quote.seller?.phone}</Typography>
                </QuotationDetailsDataItem>

                {quote?.buyer?.project_name && (
                    <QuotationDetailsDataItem title={t('PROJECT_NUMBER')}>
                        <Typography>{quote.buyer.project_name}</Typography>
                    </QuotationDetailsDataItem>
                )}
            </StyledDataWrapper>

            <StyledDataWrapper>
                <IfCondition condition={!!quote.comment_1}>
                    <QuotationDetailsDataItem title={t('COMMENT_1')}>
                        <Typography>{quote.comment_1}</Typography>
                    </QuotationDetailsDataItem>
                </IfCondition>
            </StyledDataWrapper>
        </>
    );
};
